import { render, staticRenderFns } from "./DataTableNew.vue?vue&type=template&id=3dff98b4&scoped=true"
import script from "./DataTableNew.vue?vue&type=script&lang=js"
export * from "./DataTableNew.vue?vue&type=script&lang=js"
import style0 from "./DataTableNew.vue?vue&type=style&index=0&id=3dff98b4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dff98b4",
  null
  
)

export default component.exports